export const SEATING_SETUP_CAPACITIES = [6, 8, 10, 12];
function ceilDiv(n, d) {
    return Math.max(1, Math.ceil(n / d));
}
/** Default questionnaire values from guest head count. */
export function defaultSeatingSetupAnswers(totalHeads) {
    const capacity = 8;
    return {
        assignGuests: true,
        capacity,
        tableCount: totalHeads > 0 ? "auto" : 8,
        includeVipTable: true,
        keepGroupsTogether: true,
        leaveSpareSeats: false,
    };
}
/** Resolve auto table count and map UI answers to setup_seating_plan options. */
export function mapSeatingAnswersToSetupOptions(answers, totalHeads) {
    const vipHeads = answers.includeVipTable ? 2 : 0;
    const guestHeads = Math.max(0, totalHeads - vipHeads);
    const headsForCount = guestHeads > 0 ? guestHeads : totalHeads;
    const tableCount = answers.tableCount === "auto"
        ? ceilDiv(headsForCount || 8, answers.capacity)
        : Math.max(1, Math.round(answers.tableCount));
    return {
        capacity: answers.capacity,
        tableCount,
        includeVipTable: answers.includeVipTable,
        assignGuests: answers.assignGuests,
        keepGroupsTogether: answers.keepGroupsTogether,
        leaveSpareSeats: answers.leaveSpareSeats,
        notes: answers.notes?.trim() || undefined,
    };
}
/** Estimated table count for auto mode in the setup questionnaire UI. */
export function computeAutoTableCount(totalHeads, capacity) {
    if (totalHeads <= 0)
        return 8;
    return ceilDiv(totalHeads, capacity);
}
/** @deprecated Use computeAutoTableCount + i18n in the web app. */
export function seatingSetupAutoTableHint(totalHeads, capacity) {
    if (totalHeads <= 0)
        return `Auto: 8 stołów × ${capacity} miejsc`;
    const count = computeAutoTableCount(totalHeads, capacity);
    return `Auto: ok. ${count} stołów × ${capacity} miejsc (${totalHeads} osób)`;
}
